import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
import { ConsultarParametrosLocalidadeV2Request, Types } from './types';

// ACTIONS
import {
	consultarParametrosLocalidadeV2Success,
	consultarParametrosLocalidadeV2Failure,
} from './actions';

function* consultarParametrosLocalidadeV2(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarParametrosLocalidadeV2Request } =
		request;

	let body = { ...payload };

	body = cleanEmpty(body) as ConsultarParametrosLocalidadeV2Request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`v2/parametros-localidades`,
		body,
	);

	if (response.status === 200) {
		yield put(consultarParametrosLocalidadeV2Success(response));
	} else {
		yield put(consultarParametrosLocalidadeV2Failure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTAR_PARAMETROS_LOCALIDADE_V2,
		consultarParametrosLocalidadeV2,
	),
]);
